export const getVehicleTypesMap = (data: GlossaryQuery): VehicleTypesMap => {
  const vehiclesTypesMap: VehicleTypesMap = {};

  data.vehicleTypes.forEach((vehicleType) => {
    vehiclesTypesMap[vehicleType.name] = vehicleType;
  });

  return vehiclesTypesMap;
};
export const getVehiclesMap = (data: GlossaryQuery): VehiclesMap => {
  const vehiclesMap: VehiclesMap = {};

  data.vehicles.forEach((vehicle) => {
    vehiclesMap[vehicle.id] = vehicle;
  });

  return vehiclesMap;
};

export const getVehicleTypesIndexMap = (data: GlossaryQuery): VehicleTypesIndexMap => {
  const vehicleTypesIndexMap: VehicleTypesIndexMap = {};
  data.vehicleTypes.forEach((type, index) => {
    vehicleTypesIndexMap[type.name] = index;
  });
  return vehicleTypesIndexMap;
};

export const getDollsMap = (data: GlossaryQuery): DollsMap => {
  const dollsMap: DollsMap = {};

  if (!data.dogTagComponents || !Array.isArray(data.dogTagComponents)) {
    return dollsMap;
  }

  data.dogTagComponents.forEach((doll) => {
    dollsMap[doll.id] = doll;
  });

  return dollsMap;
};

export const getNationsMap = (data: GlossaryQuery): NationsMap => {
  const nationsMap: NationsMap = {};

  data.nations.forEach((nation) => {
    nationsMap[nation.name] = nation;
  });

  return nationsMap;
};

export const getBattleTypesMap = (data: GlossaryQuery): BattleTypesMap => {
  const battleTypesMap: BattleTypesMap = {};

  data.battleTypes.forEach((battleType) => {
    if (battleType.dossierName) {
      battleTypesMap[battleType.dossierName] = battleType;
    }
  });

  return battleTypesMap;
};

export const getBattleType = (battleTypeRaw: BattleTypeName, division: DivisionName): StatBattleType => {
  return division ? ((battleTypeRaw + '_' + division) as StatBattleType) : (battleTypeRaw as StatBattleType);
};
export const getServiceIconsMap = (data: GlossaryQuery): ServiceIconsMap => {
  const result: ServiceIconsMap = {};

  if (!data.icons) return result;

  if (data.icons.mastery) {
    result['mastery'] = data.icons.mastery.reduce((map, currentData) => {
      map[currentData.level] = currentData.icons;

      return map;
    }, {} as ServiceIconsMap['mastery']);
  }

  return result;
};

export const getRankBattlesIconsMap = (data: GlossaryQuery): LeaguesRanksMap => {
  const result: LeaguesRanksMap = {};

  if (!data.rankBattles) return result;

  if (data.rankBattles.leaguesIcons) {
    const leaguesKeys = Object.keys(data.rankBattles.leaguesIcons) as (keyof LeaguesMap)[];

    leaguesKeys.forEach((leagueKey) => {
      const leagueDetails = data.rankBattles.leaguesIcons[leagueKey];
      const rankIconsMap: RankIconsMap = {};

      if (leagueDetails) {
        if (Array.isArray(leagueDetails)) {
          leagueDetails.forEach((leagueDetailsItem) => {
            rankIconsMap[leagueDetailsItem.rank] = leagueDetailsItem.icons;
          });
        }

        result[leagueKey] = rankIconsMap;
      }
    });
  }

  return result;
};

export const getRatingBattlesIconsMap = (data: GlossaryQuery): any => {
  const result: LeaguesRatingsMap = {};

  if (!data.ratingSeasons) return result;

  if (data.ratingSeasons.icons) {
    const leaguesKeys = Object.keys(data.ratingSeasons.icons) as (keyof RatingLeaguesMap)[];

    leaguesKeys.forEach((leagueKey) => {
      const leagueDetails = Object.values(data.ratingSeasons.icons[leagueKey]);
      const ratingIconsMap: RatingIconsMap = {};

      if (leagueDetails) {
        const ratingNumbersArray = leagueDetails.slice(1, leagueDetails.length - 1);
        ratingIconsMap.emblem = leagueDetails[0];
        ratingIconsMap.numbers = ratingNumbersArray;
        result[leagueKey] = ratingIconsMap;
      }
    });
  }

  return result;
};

export const getSeasonsTitlesMap = (data: GlossaryQuery): SeasonsTitlesMap => {
  const result: SeasonsTitlesMap = {};

  function getSeasonKey(key: string) {
    const match = key.match(/\d+/);
    if (match) return match[0];
    return null;
  }

  if (!data.rankBattles && !data.ratingSeasons) return result;
  if (data.rankBattles.seasons) {
    data.rankBattles.seasons.forEach((seasonData) => {
      result[getSeasonKey(seasonData.key)] = seasonData.title;
      return result;
    });
  }

  if (data.ratingSeasons.seasons) {
    data.ratingSeasons.seasons.forEach((seasonData) => {
      result[getSeasonKey(seasonData.key)] = seasonData.title;
    });
  }

  return result;
};
